import { render, staticRenderFns } from "./newsfinance.vue?vue&type=template&id=6f3a8581&scoped=true&"
import script from "./newsfinance.vue?vue&type=script&lang=js&"
export * from "./newsfinance.vue?vue&type=script&lang=js&"
import style0 from "./newsfinance.vue?vue&type=style&index=0&id=6f3a8581&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f3a8581",
  null
  
)

export default component.exports